module.exports = __webpack_public_path__ + "img/map_start.de06426b.png";